import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Ope } from "src/app/models/Ope";
import { OpePit } from "src/app/models/OpePit";
import { vignetteOpePit } from "src/app/models/vignetteOpePit";

@Injectable({
  providedIn: 'root'
})
export class sharePitSevices {
 
  public pituploadlistope : OpePit[] = [] ;
  public pituploadSelectedOpe! : OpePit ;
  public opeSelected = new BehaviorSubject<Ope>(null!);
  public mediaArrayPit = new BehaviorSubject <vignetteOpePit[]>([]);
  public mediaArrayPit$ = this.mediaArrayPit.asObservable();
  public user! : string;

  sendSelectedOpee(dataretirev: Ope ){
    this.opeSelected.next(dataretirev)
  }
   sendMediaArrayPit(dataretirev: vignetteOpePit[] ){
    this.mediaArrayPit.next(dataretirev)
  }
}